import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import { Paper, Button, IconButton } from '@material-ui/core';
import { Add, MoreHoriz } from '@material-ui/icons';

import { PaperHeader, HeaderTable } from '../../../../app/components';
import styles from './styles';

import { fetchUniversities } from '../../actions';

import {
  getUniversities,
  fetchUniversitiesState,
  getUniversitiesListRange,
} from '../../selectors';

// const universities = [
//   { name: 'McGill University', address: '845 Sherbrooke St W, Montreal, QC H3A 0G4', id: '5978d0db5a65b51ab5463261', longtitude: '45.5048	', latitude: '-73.5772', tutors: 310, students: 200},
//   { name: 'Concordia University', address: '1455 Boulevard de Maisonneuve O, Montréal, QC H3G 1M8', id: '5a5c14c6f5fcbd001494bd22', longtitude: '45.4973', latitude: '-73.579', tutors: 100, students: 140}
// ];

const PAGE_LIMIT = 10;

class UniversityCard extends React.Component {
  constructor(props) {
    super(props);
    this._onFetchUniversities = this._onFetchUniversities.bind(this);
    this._onNextPage = this._onNextPage.bind(this);
    this._onPrevPage = this._onPrevPage.bind(this);
  }
  componentDidMount() {
    const { listRange: { start, end }, universities } = this.props;
    if (_.isEmpty(universities)) {
      this._onFetchUniversities(start, end);
    }
  }

  _onFetchUniversities(start, end) {
    this.props.fetchUniversities({ start, end });
  }

  _onNextPage() {
    const { listRange: { end } } = this.props;
    this._onFetchUniversities(end, end + PAGE_LIMIT);
  }

  _onPrevPage() {
    const { listRange: { start } } = this.props;
    this._onFetchUniversities(start - PAGE_LIMIT, start);
  }

  render() {
    const {
      classes,
      onOpen,
      universities,
      listRange: { start, end, count },
      fetchState: { loading },
    } = this.props;
    return (
        <Paper className={classes.paper}>
          <PaperHeader text="Institutions">
            <Button color="primary" variant="fab" mini onClick={() => onOpen('add')}>
              <Add />
            </Button>
          </PaperHeader>
          <HeaderTable
            label="Institutions"
            data={universities}
            Action={<IconButton><MoreHoriz /></IconButton>}
            paging
            start={start}
            end={end}
            count={count}
            onNext={this._onNextPage}
            onPrev={this._onPrevPage}
            loading={loading}
          />
        </Paper>
    );
  }
}

UniversityCard.propTypes = {
  classes: PropTypes.object.isRequired,
  universities: PropTypes.array.isRequired,
  fetchUniversities: PropTypes.func.isRequired,
  fetchState: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    error: PropTypes.string.isRequired,
  }).isRequired,
  listRange: PropTypes.shape({
    start: PropTypes.number.isRequired,
    end: PropTypes.number.isRequired,
    count: PropTypes.string.isRequired,
  }).isRequired,
};

const mapStateToProps = state => ({
  universities: getUniversities(state),
  fetchState: fetchUniversitiesState(state),
  listRange: getUniversitiesListRange(state),
});

const mapDispatchToProps = { fetchUniversities };

export default compose(
  withStyles(styles, { name: 'UniversityCard' }),
  connect(mapStateToProps, mapDispatchToProps)
)(UniversityCard);



// WEBPACK FOOTER //
// ./src/modules/universities/cards/UniversityCard/index.js